import { Close } from "@mui/icons-material";
import { Box, Dialog, IconButton } from "@mui/material";
import { observer } from "mobx-react-lite";
import FigmaFaqSection from "../../Home/Figma/FigmaFaqSection/FigmaFaqSection";
import FigmaHeaderSection from "../../Home/Figma/FigmaHeaderSection/FigmaHeaderSection";
import FigmaInstallSection from "../../Home/Figma/FigmaInstallSection/FigmaInstallSection";
import styles from "./FigmaPopup.module.scss";

interface IProps {
	open: boolean;
	onClose: () => void;
}

const FigmaPopup = ({ open, onClose }: IProps) => {
	return (
		<Dialog
			classes={{
				paper: styles.figmaPopupContainer,
			}}
			open={open}
			onClose={onClose}
			maxWidth="lg"
			fullWidth
		>
			<IconButton onClick={onClose} className={styles.closeButton}>
				<Close />
			</IconButton>
			<Box className={styles.content}>
				<Box className={styles.figmaInstructionsContainer}>
					<FigmaHeaderSection />
					<FigmaInstallSection />
				</Box>
				<FigmaFaqSection />
			</Box>
		</Dialog>
	);
};

export default observer(FigmaPopup);
